<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-modal
    :id="id"
    modal-class="giga-modal modal-notification"
    content-class=""
    size="md"
    hide-footer
    :no-close-on-esc="!this.backdropClose"
    :no-close-on-backdrop="!this.backdropClose"
    hide-header
    centered
    lazy
  >
    <h2 class="giga-modal_title" v-html="modal_title"></h2>
    <div class="giga-modal_body">
      <p v-html="content"></p>
    </div>
    <div class="giga-modal_footer">
      <div class="giga-button">
        <button
          class="giga-blue_outlined_button no-icon"
          @click="$emit('close')"
        >
          {{ $t("no") }}
        </button>
      </div>
      <div class="giga-button">
        <button class="giga-green_button no-icon" @click="$emit('yesClick')">
          <b-spinner variant="light" small v-if="loader"></b-spinner>
          {{ $t("yes") }}
        </button>
      </div>
    </div>
    <div></div>
  </b-modal>
</template>

<script>
export default {
  name: "confirmModal",
  props: [
    "id",
    "backdropClose",
    "content",
    "fontSize",
    "loader",
    "modal_title"
  ],
  methods: {},
  computed: {}
};
</script>
